export default __webpack_public_path__ + "static/media/logo-grafana.d6a7175d.png";